import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import {
    CHARGEBACKS_DESCRIPTION,
    COLLECTION_FEE_DESCRIPTION,
    NON_FACTORED_DESCRIPTION,
    COLLECTION_PREVIOUS_PAYMENTS_DESCRIPTION,
    COLLECTION_INVOICE_BALANCE_DESCRIPTION
} from '../../../../constants/copy.constants';
import {
    CollectionCheck,
    GetCollectionChecksRequest,
    GetCollectionChecksResponse
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@Component({
    selector: 'collections-grouped-table-header-footer',
    styleUrls: ['./collections.grouped-table-header-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <lsq-data-table
            [dataSource]="dataSource"
            [isHeaderOnly]="type === 'header'"
            [isFooterOnly]="type === 'footer'"
            [layoutFixed]="true"
            [hasStickyHeader]="type === 'header'"
        >
            <lsq-hidden-column width="10%">
                <ng-template [custom-footer-cell] let-row="row">
                    <div
                        [ngStyle]="{
                            width: '10%'
                        }"
                    >
                        Total
                    </div>
                </ng-template>
            </lsq-hidden-column>

            <lsq-hidden-column
                width="6%"
                [column]="{ key: 'checkNumberHidden' }"
            ></lsq-hidden-column>

            <lsq-column
                [column]="{
                    header: 'Invoice #',
                    key: 'invoiceNumber',
                    width: '12%',
                    sortable: false,
                    className: 'first-child-pl'
                }"
            >
            </lsq-column>

            <lsq-date-column
                [column]="{
                    header: 'Invoice Date',
                    key: 'invoiceDate',
                    width: '8%',
                    sortable: false
                }"
            >
            </lsq-date-column>

            <lsq-date-column
                [column]="{
                    header: 'Invoice Age',
                    key: 'invoiceAge',
                    width: '8%',
                    sortable: false
                }"
            >
            </lsq-date-column>

            <lsq-currency-column
                [column]="{
                    header: 'Invoice<br/>Amount',
                    className: 'purchase-amount-col',
                    key: 'checkInvoiceAmount',
                    width: '8%',
                    sortable: false
                }"
                [totalValue]="totals?.checkInvoiceAmountTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Payment<br/>Amount',
                    key: 'checkPaymentAmount',
                    width: '8%',
                    sortable: false
                }"
                [totalValue]="totals?.checkPaymentAmountTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Chargebacks',
                    key: 'checkChargebacks',
                    width: '8%',
                    sortable: false,
                    headerPopoverContent: checkChargebackPopoverContent
                }"
                [totalValue]="totals?.checkChargebacksTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Non-Factored',
                    key: 'checkNonFactored',
                    width: '8%',
                    sortable: false,
                    headerPopoverContent: nonFactoredPopoverContent
                }"
                [totalValue]="totals?.checkNonFactoredTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Previous<br/>Payments',
                    key: 'checkPreviousPayments',
                    width: '8%',
                    sortable: false,
                    headerPopoverContent: previousPaymentsPopoverContent
                }"
                [totalValue]="totals?.checkPreviousPaymentsTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Invoice<br/>Balance',
                    key: 'checkInvoiceBalance',
                    width: '8%',
                    sortable: false,
                    headerPopoverContent: invoiceBalancePopoverContent
                }"
                [totalValue]="totals?.checkInvoiceBalanceTotal"
            >
            </lsq-currency-column>

            <lsq-currency-column
                [column]="{
                    header: 'Collection<br/>Fee',
                    key: 'checkCollectionFees',
                    width: '8%',
                    sortable: false,
                    headerPopoverContent: collectionFeePopoverContent
                }"
                [totalValue]="totals?.checkCollectionFeesTotal"
            >
            </lsq-currency-column>
        </lsq-data-table>
    `
})
export class CollectionsGroupedTableHeaderFooterComponent {
    @Input() public type: 'header' | 'footer';
    @Input() public totals: any;
    @Input() public dataSource: LsqApiServiceListSource<
        GetCollectionChecksResponse,
        GetCollectionChecksRequest,
        CollectionCheck[]
    >;

    public checkChargebackPopoverContent = CHARGEBACKS_DESCRIPTION;
    public nonFactoredPopoverContent = NON_FACTORED_DESCRIPTION;
    public collectionFeePopoverContent = COLLECTION_FEE_DESCRIPTION;
    public previousPaymentsPopoverContent = COLLECTION_PREVIOUS_PAYMENTS_DESCRIPTION;
    public invoiceBalancePopoverContent = COLLECTION_INVOICE_BALANCE_DESCRIPTION;
}
